/**
 * Normalizes text for comparison (trim, lowercase, collapse whitespace)
 */
export function normalizeText(text) {
    return text.trim().toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ');
}
/**
 * Checks if user answer matches correct answer (flexible: ignores case, extra spaces, articles,
 * and accepts both with and without parenthetical content)
 */
export function checkAnswer(userInput, correctAnswer, alternatives = []) {
    // Variant 1: remove parentheses AND their content (e.g. "the (определённый)" -> "the")
    const normalizeClean = (s) => s.trim().toLowerCase().replace(/ё/g, 'е').replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim().replace(/^(a|an|the)\s+/i, '');
    // Variant 2: remove only parentheses, keep content inside (e.g. "the (определённый)" -> "the определённый")
    const normalizeFull = (s) => s.trim().toLowerCase().replace(/ё/g, 'е').replace(/\s*[\(\)]\s*/g, ' ').replace(/\s+/g, ' ').trim().replace(/^(a|an|the)\s+/i, '');
    const inputClean = normalizeClean(userInput);
    const inputFull = normalizeFull(userInput);
    const allAnswers = [correctAnswer, ...alternatives];
    // Check against "clean" versions (parenthetical content removed)
    if (allAnswers.some(answer => normalizeClean(answer) === inputClean))
        return true;
    // Check against "full" versions (only parentheses removed, content kept)
    if (allAnswers.some(answer => normalizeFull(answer) === inputFull))
        return true;
    // Cross-check: user input without parens vs answer with parens content
    if (allAnswers.some(answer => normalizeFull(answer) === inputClean))
        return true;
    // Если ответ содержит запятую ("и, а") — принимаем каждую часть по отдельности
    for (const answer of allAnswers) {
        if (answer.includes(',')) {
            const partsClean = answer.split(',').map(p => normalizeClean(p)).filter(Boolean);
            if (partsClean.some(part => part === inputClean || part === inputFull))
                return true;
            const partsFull = answer.split(',').map(p => normalizeFull(p)).filter(Boolean);
            if (partsFull.some(part => part === inputClean || part === inputFull))
                return true;
        }
    }
    return false;
}
/**
 * Generates word difficulty indicator text
 */
export function getDifficultyText(errorCount, errorStreak) {
    if (errorCount >= 10)
        return '💀 Кошмарное слово';
    if (errorCount >= 5)
        return '🔥 Сложное слово';
    if (errorStreak >= 3)
        return '⚠️ Проблемное слово';
    if (errorCount >= 2)
        return '💡 Требует внимания';
    return null;
}
/**
 * Calculates XP to next level (simple quadratic formula)
 */
export function getXpToNextLevel(level) {
    return Math.floor(100 * Math.pow(level, 1.5));
}
//# sourceMappingURL=text.js.map